// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a920029e","977":"c4d40c7a"}[chunkId] + ".chunk.js";
};